export default "__VITE_ASSET__CJx75drL__"